var Geometry =
/** @class */
function () {
  function Geometry() {}

  Geometry.tag = 'c-geometry';
  return Geometry;
}();

export { Geometry };